module.exports = __webpack_public_path__ + "img/arrow-right.1b4ed5ee.svg";